import { GlBadge, GlTab, GlTabs, GlLoadingIcon } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { s__ } from '~/locale';
import { InternalEvents } from '../../../../tracking/index.js?vue3';
import { SCOPE, MIN_ACCESS_LEVEL, TAB_NAME } from '~/ci/catalog/constants';
export default {
    name: 'CatalogTabs',
    components: {
        GlBadge,
        GlTab,
        GlTabs,
        GlLoadingIcon
    },
    mixins: [
        InternalEvents.mixin()
    ],
    props: {
        isLoading: {
            type: Boolean,
            required: true
        },
        resourceCounts: {
            type: Object,
            required: true
        }
    },
    emits: [
        'tab-change'
    ],
    computed: {
        tabs () {
            return [
                {
                    text: s__('CiCatalog|All'),
                    scope: SCOPE.all,
                    testId: 'resources-all-tab',
                    count: this.resourceCounts.all,
                    name: TAB_NAME.all
                },
                {
                    text: s__('CiCatalog|Your groups'),
                    scope: SCOPE.namespaces,
                    testId: 'resources-group-tab',
                    count: this.resourceCounts.namespaces,
                    name: TAB_NAME.namespaces
                },
                {
                    text: s__('CiCatalog|Analytics'),
                    scope: SCOPE.namespaces,
                    testId: 'resources-analytics-tab',
                    count: this.resourceCounts.analytics,
                    minAccessLevel: MIN_ACCESS_LEVEL,
                    name: TAB_NAME.analytics
                }
            ];
        },
        showLoadingIcon () {
            return this.isLoading;
        }
    },
    methods: {
        onTabChange (tab) {
            if (tab.name === TAB_NAME.analytics) {
                this.trackEvent('click_analytics_tab_on_ci_catalog');
            }
            this.$emit('tab-change', {
                name: tab.name,
                scope: tab.scope,
                minAccessLevel: tab.minAccessLevel
            });
        }
    }
};
